/**
 * @generated SignedSource<<f48625eb497867c07953744601c3118f>>
 * @relayHash 3bbe35fb31f794e7cd0a4e7e49fbad62
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 32b0a85334f20aa945261bedcc77e8dcee32c8cb769e7eacfa88de3117cec663

import type { ConcreteRequest } from 'relay-runtime';
export type TopNavSettingsMenuQuery$variables = {
  cloudId: string;
  skipContactAdminCheck: boolean;
  skipDelegatedAdminCheck: boolean;
  skipJsmAdminCheck: boolean;
};
export type TopNavSettingsMenuQuery$data = {
  readonly contactAdmin?: {
    readonly isContactAdministratorFormEnabled: boolean | null;
  } | null;
  readonly jira?: {
    readonly canManageCustomOnboarding: boolean | null;
  } | null;
  readonly jsmAdmin?: {
    readonly hasJsmAdminAccess: boolean | null;
  } | null;
};
export type TopNavSettingsMenuQuery = {
  response: TopNavSettingsMenuQuery$data;
  variables: TopNavSettingsMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipContactAdminCheck"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipDelegatedAdminCheck"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipJsmAdminCheck"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = [
  (v4/*: any*/)
],
v6 = [
  {
    "condition": "skipDelegatedAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canManageCustomOnboarding",
            "args": [
              (v4/*: any*/),
              {
                "kind": "Literal",
                "name": "key",
                "value": "MANAGE_CUSTOM_ONBOARDING"
              }
            ],
            "kind": "ScalarField",
            "name": "hasGlobalPermission"
          }
        ]
      }
    ]
  },
  {
    "condition": "skipJsmAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": "jsmAdmin",
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "hasJsmAdminAccess"
          }
        ]
      }
    ]
  },
  {
    "condition": "skipContactAdminCheck",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": "contactAdmin",
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "kind": "ScalarField",
            "name": "isContactAdministratorFormEnabled"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v6/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopNavSettingsMenuQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "id": "32b0a85334f20aa945261bedcc77e8dcee32c8cb769e7eacfa88de3117cec663",
    "metadata": {},
    "name": "TopNavSettingsMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1bc9c4cf50ac75fa2a2f8ff4b86d7d88";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
